(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ptd-home-feature"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ptd-home-feature')) {
  customElements.define('ptd-home-feature', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.dataset.autoplayVideo !== 'true') return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.video.muted = true; this.video.defaultMuted = true; this.video.loop = true;
      this.updatePlayback = () => {
        if (this.inView && !this.motion.matches && !document.hidden) this.video.play().catch(() => {});
        else this.video.pause();
      };
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting; this.updatePlayback();
      }, { threshold: 0.25 });
      this.observer.observe(this.video);
      document.addEventListener('visibilitychange', this.updatePlayback, options);
      this.motion.addEventListener('change', this.updatePlayback, options);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.video?.pause(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ptd-home-signup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ptd-signup-preview')) { customElements.define('ptd-signup-preview', class extends HTMLElement {
  connectedCallback() { this.abort = new AbortController(); const options = { signal: this.abort.signal }; const form = this.querySelector('[data-signup]'); const success = this.querySelector('[data-success]'); const birthday = this.querySelector('[data-birthday]'); if (birthday) birthday.addEventListener('input', () => { const value = birthday.value.trim(); const parts = /^(\d{2})\/(\d{2})$/.exec(value); const date = parts ? new Date(Date.UTC(2000, Number(parts[2]) - 1, Number(parts[1]))) : null; const valid = !value || parts && date.getUTCDate() === Number(parts[1]) && date.getUTCMonth() + 1 === Number(parts[2]); birthday.setCustomValidity(valid ? '' : birthday.dataset.error); }, options); if (!form || !success) return; form.addEventListener('submit', event => { event.preventDefault(); form.hidden = true; success.hidden = false; }, options); this.querySelector('[data-reset]').addEventListener('click', () => { form.hidden = false; success.hidden = true; }, options); }
  disconnectedCallback() { this.abort?.abort(); }
}); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
